"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameConstants = void 0;
var GameConstants = /** @class */ (function () {
    function GameConstants() {
    }
    GameConstants.VERSION = "0.0";
    GameConstants.DEVELOPMENT = false;
    GameConstants.SHOW_DEBUG_GEOMETRY = false;
    GameConstants.VERBOSE = false;
    GameConstants.GAME_WIDTH = 768;
    GameConstants.GAME_HEIGHT = 1024;
    GameConstants.NUM_ITEMS = 39;
    GameConstants.MODE_2_AVAILABLE_LEVEL = 7;
    GameConstants.RESTART_ITEM = 23;
    GameConstants.SHOW_INCREMENT_PERCENTAGE = .5;
    GameConstants.GAME_MODE_1 = "game mode 1";
    GameConstants.GAME_MODE_2 = "game mode 2";
    GameConstants.ACHIEVEMENTS = "achievements";
    GameConstants.SHOP = "shop";
    GameConstants.UP_DIR = "up";
    GameConstants.DOWN_DIR = "down";
    GameConstants.ACHIEVEMENTS_UNLOCK = "unlock";
    GameConstants.ACHIEVEMENTS_LEVEL = "level";
    GameConstants.ACHIEVEMENTS_BUY = "buy";
    GameConstants.ACHIEVEMENTS_MERGE = "merge";
    GameConstants.ACHIEVEMENTS_TAP = "tap";
    GameConstants.ACHIEVEMENTS_OPEN_BOX = "open box";
    GameConstants.ACHIEVEMENTS_OPEN_MINSTERY = "open mistery";
    GameConstants.CELLS_SEQUENCE_DESKTOP = [{ r: 0, c: 3 }, { r: 0, c: 2 }, { r: 0, c: 4 }, { r: 1, c: 5 }, { r: 0, c: 5 }, { r: 2, c: 5 },
        { r: 1, c: 1 }, { r: 0, c: 1 }, { r: 2, c: 1 }, { r: 3, c: 3 }, { r: 3, c: 4 }, { r: 3, c: 2 },
        { r: 3, c: 5 }, { r: 3, c: 1 },
        { r: 1, c: 6 }, { r: 2, c: 6 }, { r: 0, c: 6 }, { r: 3, c: 6 },
        { r: 1, c: 0 }, { r: 2, c: 0 }, { r: 0, c: 0 }, { r: 3, c: 0 },
        { r: 1, c: 7 }, { r: 2, c: 7 }, { r: 0, c: 7 }, { r: 3, c: 7 },
        { r: 4, c: 4 }, { r: 4, c: 3 }, { r: 4, c: 5 }, { r: 4, c: 2 }, { r: 4, c: 6 }, { r: 4, c: 1 }, { r: 4, c: 7 }, { r: 4, c: 0 }
    ];
    GameConstants.BOARD_POSITION_AND_SCALE_DESKTOP = [
        { dr: -1.65, dc: -3, s: 1 },
        { dr: -1.2, dc: -3, s: .775 },
        { dr: -1.2, dc: -3, s: .775 },
        { dr: -1.2, dc: -3, s: .775 },
        { dr: -1.2, dc: -3.5, s: .775 },
        { dr: -1.2, dc: -3.5, s: .775 },
        { dr: -1.2, dc: -3.5, s: .775 },
        { dr: -1.2, dc: -3, s: .775 },
        { dr: -1.2, dc: -3, s: .775 },
        { dr: -1.2, dc: -3, s: .775 },
        { dr: -1.725, dc: -3, s: .6 },
        { dr: -1.725, dc: -3, s: .6 },
        { dr: -1.725, dc: -3, s: .6 },
        { dr: -1.725, dc: -3, s: .6 },
        { dr: -1.725, dc: -3, s: .6 },
        { dr: -1.725, dc: -3.5, s: .6 },
        { dr: -1.725, dc: -3.5, s: .6 },
        { dr: -1.725, dc: -3.5, s: .6 },
        { dr: -1.725, dc: -3.5, s: .6 },
        { dr: -1.725, dc: -3, s: .6 },
        { dr: -1.725, dc: -3, s: .6 },
        { dr: -1.725, dc: -3, s: .6 },
        { dr: -1.725, dc: -3, s: .6 },
        { dr: -1.725, dc: -3.5, s: .6 },
        { dr: -1.725, dc: -3.5, s: .6 },
        { dr: -1.725, dc: -3.5, s: .6 },
        { dr: -1.725, dc: -3.5, s: .6 },
        { dr: -2.25, dc: -3.5, s: .5 },
        { dr: -2.25, dc: -3.5, s: .5 },
        { dr: -2.25, dc: -3.5, s: .5 },
        { dr: -2.25, dc: -3.5, s: .5 },
        { dr: -2.25, dc: -3.5, s: .5 },
        { dr: -2.25, dc: -3.5, s: .5 },
        { dr: -2.25, dc: -3.5, s: .5 },
        { dr: -2.25, dc: -3.5, s: .5 }
    ];
    GameConstants.CELLS_SEQUENCE_TACTILE = [
        { r: 1, c: 2 },
        { r: 1, c: 3 },
        { r: 1, c: 1 },
        { r: 4, c: 2 },
        { r: 4, c: 3 },
        { r: 4, c: 1 },
        { r: 2, c: 4 },
        { r: 3, c: 4 },
        { r: 1, c: 4 },
        { r: 4, c: 4 },
        { r: 0, c: 3 },
        { r: 0, c: 2 },
        { r: 0, c: 4 },
        { r: 0, c: 1 },
        { r: 2, c: 0 },
        { r: 3, c: 0 },
        { r: 1, c: 0 },
        { r: 4, c: 0 },
        { r: 0, c: 0 },
        { r: 5, c: 2 },
        { r: 5, c: 3 },
        { r: 5, c: 1 },
        { r: 5, c: 4 },
        { r: 5, c: 0 },
        { r: 6, c: 2 },
        { r: 6, c: 3 },
        { r: 6, c: 1 },
        { r: 6, c: 4 },
        { r: 6, c: 0 },
        { r: 7, c: 2 },
        { r: 7, c: 3 },
        { r: 7, c: 1 },
        { r: 7, c: 4 },
        { r: 7, c: 0 }
    ];
    GameConstants.BOARD_POSITION_AND_SCALE_TACTILE = [
        { dr: -2.5, dc: -2, s: 1.25 },
        { dr: -2, dc: -2, s: 1.25 },
        { dr: -2, dc: -2, s: 1.25 },
        { dr: -2, dc: -2, s: 1.25 },
        { dr: -2.5, dc: -2, s: 1.25 },
        { dr: -2.5, dc: -2, s: 1.25 },
        { dr: -2.5, dc: -2, s: 1.25 },
        { dr: -2.5, dc: -2.5, s: 1.05 },
        { dr: -2.5, dc: -2.5, s: 1.05 },
        { dr: -2.5, dc: -2.5, s: 1.05 },
        { dr: -2.5, dc: -2.5, s: 1.05 },
        { dr: -2, dc: -2.5, s: 1.05 },
        { dr: -2, dc: -2.5, s: 1.05 },
        { dr: -2, dc: -2.5, s: 1.05 },
        { dr: -2, dc: -2.5, s: 1.05 },
        { dr: -2, dc: -2, s: 0.95 },
        { dr: -2, dc: -2, s: 0.95 },
        { dr: -2, dc: -2, s: 0.95 },
        { dr: -2, dc: -2, s: 0.95 },
        { dr: -2, dc: -2, s: 0.95 },
        { dr: -2.5, dc: -2, s: 0.915 },
        { dr: -2.5, dc: -2, s: 0.915 },
        { dr: -2.5, dc: -2, s: 0.915 },
        { dr: -2.5, dc: -2, s: 0.915 },
        { dr: -2.5, dc: -2, s: 0.915 },
        { dr: -3, dc: -2, s: 0.915 },
        { dr: -3, dc: -2, s: 0.915 },
        { dr: -3, dc: -2, s: 0.915 },
        { dr: -3, dc: -2, s: 0.915 },
        { dr: -3, dc: -2, s: 0.915 },
        { dr: -3.65, dc: -2, s: 0.915 },
        { dr: -3.65, dc: -2, s: 0.915 },
        { dr: -3.65, dc: -2, s: 0.915 },
        { dr: -3.65, dc: -2, s: 0.915 },
        { dr: -3.65, dc: -2, s: 0.915 }
    ];
    GameConstants.BOARD_POSITION_AND_SCALE_TACTILE_1_75 = [
        { dr: -2.5, dc: -2, s: 1.25 },
        { dr: -2, dc: -2, s: 1.25 },
        { dr: -2, dc: -2, s: 1.25 },
        { dr: -2, dc: -2, s: 1.25 },
        { dr: -2.65, dc: -2, s: 1.15 },
        { dr: -2.65, dc: -2, s: 1.15 },
        { dr: -2.65, dc: -2, s: 1.15 },
        { dr: -2.65, dc: -2.5, s: 1.15 },
        { dr: -2.65, dc: -2.5, s: 1.15 },
        { dr: -2.65, dc: -2.5, s: 1.15 },
        { dr: -2.65, dc: -2.5, s: 1.15 },
        { dr: -2.15, dc: -2.5, s: .915 },
        { dr: -2.15, dc: -2.5, s: .915 },
        { dr: -2.15, dc: -2.5, s: .915 },
        { dr: -2.15, dc: -2.5, s: .915 },
        { dr: -2.15, dc: -2, s: .9 },
        { dr: -2.15, dc: -2, s: .9 },
        { dr: -2.15, dc: -2, s: .9 },
        { dr: -2.15, dc: -2, s: .9 },
        { dr: -2.15, dc: -2, s: .9 },
        { dr: -2.65, dc: -2, s: 0.775 },
        { dr: -2.65, dc: -2, s: 0.775 },
        { dr: -2.65, dc: -2, s: 0.775 },
        { dr: -2.65, dc: -2, s: 0.775 },
        { dr: -2.65, dc: -2, s: 0.775 },
        { dr: -3.15, dc: -2, s: 0.675 },
        { dr: -3.15, dc: -2, s: 0.675 },
        { dr: -3.15, dc: -2, s: 0.675 },
        { dr: -3.15, dc: -2, s: 0.675 },
        { dr: -3.15, dc: -2, s: 0.675 },
        { dr: -3.7, dc: -2, s: 0.6 },
        { dr: -3.7, dc: -2, s: 0.6 },
        { dr: -3.7, dc: -2, s: 0.6 },
        { dr: -3.7, dc: -2, s: 0.6 },
        { dr: -3.7, dc: -2, s: 0.6 }
    ];
    GameConstants.BOARD_POSITION_AND_SCALE_TACTILE_2 = [
        { dr: -2.5, dc: -2, s: 1.25 },
        { dr: -2, dc: -2, s: 1.25 },
        { dr: -2, dc: -2, s: 1.25 },
        { dr: -2, dc: -2, s: 1.25 },
        { dr: -2.5, dc: -2, s: 1.25 },
        { dr: -2.5, dc: -2, s: 1.25 },
        { dr: -2.5, dc: -2, s: 1.25 },
        { dr: -2.5, dc: -2.5, s: 1.2 },
        { dr: -2.5, dc: -2.5, s: 1.2 },
        { dr: -2.5, dc: -2.5, s: 1.2 },
        { dr: -2.5, dc: -2.5, s: 1.2 },
        { dr: -2.15, dc: -2.5, s: 1.1 },
        { dr: -2.15, dc: -2.5, s: 1.1 },
        { dr: -2.15, dc: -2.5, s: 1.1 },
        { dr: -2.15, dc: -2.5, s: 1.1 },
        { dr: -2.15, dc: -2, s: .95 },
        { dr: -2.15, dc: -2, s: .95 },
        { dr: -2.15, dc: -2, s: .95 },
        { dr: -2.15, dc: -2, s: .95 },
        { dr: -2.15, dc: -2, s: .95 },
        { dr: -2.65, dc: -2, s: 0.9 },
        { dr: -2.65, dc: -2, s: 0.9 },
        { dr: -2.65, dc: -2, s: 0.9 },
        { dr: -2.65, dc: -2, s: 0.9 },
        { dr: -2.65, dc: -2, s: 0.9 },
        { dr: -3.15, dc: -2, s: .825 },
        { dr: -3.15, dc: -2, s: .825 },
        { dr: -3.15, dc: -2, s: .825 },
        { dr: -3.15, dc: -2, s: .825 },
        { dr: -3.15, dc: -2, s: .825 },
        { dr: -3.65, dc: -2, s: 0.725 },
        { dr: -3.65, dc: -2, s: 0.725 },
        { dr: -3.65, dc: -2, s: 0.725 },
        { dr: -3.65, dc: -2, s: 0.725 },
        { dr: -3.65, dc: -2, s: 0.725 }
    ];
    GameConstants.BOARD_POSITION_AND_SCALE_TACTILE_1_45 = [
        { dr: -2.5, dc: -2, s: 1.25 },
        { dr: -2.05, dc: -2, s: 1.25 },
        { dr: -2.05, dc: -2, s: 1.25 },
        { dr: -2.05, dc: -2, s: 1.25 },
        { dr: -2.65, dc: -2, s: .975 },
        { dr: -2.65, dc: -2, s: .975 },
        { dr: -2.65, dc: -2, s: .975 },
        { dr: -2.65, dc: -2.5, s: .975 },
        { dr: -2.65, dc: -2.5, s: .975 },
        { dr: -2.65, dc: -2.5, s: .975 },
        { dr: -2.65, dc: -2.5, s: .975 },
        { dr: -2.05, dc: -2.5, s: .81 },
        { dr: -2.05, dc: -2.5, s: .81 },
        { dr: -2.05, dc: -2.5, s: .81 },
        { dr: -2.05, dc: -2.5, s: .81 },
        { dr: -2.05, dc: -2, s: .81 },
        { dr: -2.05, dc: -2, s: .81 },
        { dr: -2.05, dc: -2, s: .81 },
        { dr: -2.05, dc: -2, s: .81 },
        { dr: -2.05, dc: -2, s: .81 },
        { dr: -2.65, dc: -2, s: 0.67 },
        { dr: -2.65, dc: -2, s: 0.67 },
        { dr: -2.65, dc: -2, s: 0.67 },
        { dr: -2.65, dc: -2, s: 0.67 },
        { dr: -2.65, dc: -2, s: 0.67 },
        { dr: -3.1, dc: -2, s: 0.58 },
        { dr: -3.1, dc: -2, s: 0.58 },
        { dr: -3.1, dc: -2, s: 0.58 },
        { dr: -3.1, dc: -2, s: 0.58 },
        { dr: -3.1, dc: -2, s: 0.58 },
        { dr: -3.65, dc: -2, s: 0.5 },
        { dr: -3.65, dc: -2, s: 0.5 },
        { dr: -3.65, dc: -2, s: 0.5 },
        { dr: -3.65, dc: -2, s: 0.5 },
        { dr: -3.65, dc: -2, s: 0.5 }
    ];
    GameConstants.BOARD_POSITION_AND_SCALE_TACTILE_1_3 = [
        { dr: -2.5, dc: -2, s: 1.25 },
        { dr: -2.1, dc: -2, s: 1.15 },
        { dr: -2.1, dc: -2, s: 1.15 },
        { dr: -2.1, dc: -2, s: 1.15 },
        { dr: -2.6, dc: -2, s: .9 },
        { dr: -2.6, dc: -2, s: .9 },
        { dr: -2.6, dc: -2, s: .9 },
        { dr: -2.6, dc: -2.5, s: .9 },
        { dr: -2.6, dc: -2.5, s: .9 },
        { dr: -2.6, dc: -2.5, s: .9 },
        { dr: -2.6, dc: -2.5, s: .9 },
        { dr: -2.15, dc: -2.5, s: .725 },
        { dr: -2.15, dc: -2.5, s: .725 },
        { dr: -2.15, dc: -2.5, s: .725 },
        { dr: -2.15, dc: -2.5, s: .725 },
        { dr: -2.15, dc: -2, s: .725 },
        { dr: -2.15, dc: -2, s: .725 },
        { dr: -2.15, dc: -2, s: .725 },
        { dr: -2.15, dc: -2, s: .725 },
        { dr: -2.15, dc: -2, s: .725 },
        { dr: -2.65, dc: -2, s: 0.6 },
        { dr: -2.65, dc: -2, s: 0.6 },
        { dr: -2.65, dc: -2, s: 0.6 },
        { dr: -2.65, dc: -2, s: 0.6 },
        { dr: -2.65, dc: -2, s: 0.6 },
        { dr: -3.15, dc: -2, s: 0.5 },
        { dr: -3.15, dc: -2, s: 0.5 },
        { dr: -3.15, dc: -2, s: 0.5 },
        { dr: -3.15, dc: -2, s: 0.5 },
        { dr: -3.15, dc: -2, s: 0.5 },
        { dr: -3.7, dc: -2, s: 0.45 },
        { dr: -3.7, dc: -2, s: 0.45 },
        { dr: -3.7, dc: -2, s: 0.45 },
        { dr: -3.7, dc: -2, s: 0.45 },
        { dr: -3.7, dc: -2, s: 0.45 }
    ];
    GameConstants.SAVED_GAME_DATA_KEY = "merge-cakes-data";
    return GameConstants;
}());
exports.GameConstants = GameConstants;
